import { call, put, takeLatest } from 'redux-saga/effects';
import { layoutActions as actions } from '.';
import request from 'utils/request';

function* loadUserProfile() {
  try {
    const response = yield call(
      request,
      `${process.env.REACT_APP_API_URL}/auth/profile`
    );

    // Check if response is the data itself or has a data property
    const userData = response.data || response;

    // ✅ Set user_email cookie for audit logging
    if (userData?.email || userData?.mail) {
      const userEmail = userData.email || userData.mail;
      const date = new Date();
      date.setTime(date.getTime() + 24 * 3600 * 1000); // 24 hours
      document.cookie = `user_email=${encodeURIComponent(
        userEmail
      )};expires=${date.toUTCString()};path=/`;
    } else {
      console.warn('⚠️ User profile loaded but email not found:', userData);
    }

    yield put(actions.userProfileLoaded(userData));
  } catch (e: any) {
    // Extract serializable error message from response to avoid Redux errors
    let errorMessage = 'Failed to load user profile';
    if (e.message) {
      errorMessage = e.message;
    } else if (e.response) {
      // If it's a Response object, extract status and statusText
      if (e.response.status && e.response.statusText) {
        errorMessage = `HTTP Error ${e.response.status}: ${e.response.statusText}`;
      } else if (typeof e.response === 'string') {
        errorMessage = e.response;
      }
    }
    yield put(actions.profileError(errorMessage));
  }
}

export function* layoutSaga() {
  yield takeLatest(actions.loadUserProfile.type, loadUserProfile);
}
